<template>
  <div class="comment" :class="{'comment__default': isCurrentUser, 'comment__reverse': !isCurrentUser}">
    <div class="user-info" :class="{'user-info__default': isCurrentUser, 'user-info__reverse': !isCurrentUser}">
      <div class="user-info__icon">{{userInitials}}</div>
      <div class="user-info__date">{{comment.timestamp | formattedTime}}</div>
    </div>
     <div class="comment-message" :class="{'comment-message__default': isCurrentUser, 'comment-message__reverse': !isCurrentUser}">
       <span class="comment-message__email">{{comment.email}}</span>
       <div class="comment-message__text" v-html="comment.comment"></div>
     </div>
  </div>
</template>

<script>
import filters from '@/common/Filters'
import Helper from '@/services/Helper'
// eslint-disable-next-line no-unused-vars
import Comments from './Comments'

/**
 * Comment component. Used in {@link Comments}
 */
export default {
  name: 'Comment',
  props: {
    comment: {
      type: Object,
      required: true
    },
    isCurrentUser: Boolean
  },
  data () {
    return {
      anotherUserColor: '#1d3bdd'
    }
  },
  computed: {
    additionalInitialsColor () {
      return this.isCurrentUser ? '' : this.anotherUserColor
    },
    userInitials: function () {
      return Helper.getInitialsFromEmail(this.comment.email)
    }
  },
  components: {},
  filters: {
    ...filters
  }
}
</script>

<style scoped lang="scss">

  .comment {
    display: flex;

    &__reverse {
      flex-direction: row-reverse;
    }

    &__default {
      flex-direction: row;
    }
  }

  .user-info {
      margin-right: 30px;
      align-items: center;
      flex-direction: column;

      &__reverse {
        margin-left: 30px;
        margin-right: 0
      }

      &__default {
        margin-right: 30px;
        margin-left: 0
      }

      &__date {
        color: $rfx-medium-grey;
        margin-top: 10px;
        font-size: 12px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 2.5;
        letter-spacing: normal;
      }

      &__icon {
        display: flex;
        width: 40px;
        height: 40px;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        color: #fff;
        font-size: 20px;
        text-transform: uppercase;
        border-radius: 50%;
        background-color: $rfx-bright-turquoise;
        -webkit-print-color-adjust: exact;
      }
  }

  .comment-message {
    flex: 2 1;
    background: white;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 20px;

    &__default {
      background: white;
    }

    &__reverse {
      background: rgba(40, 74, 255, 0.12);
    }

    &__email {
      font-weight: 500;
      display: block;
      margin-bottom: 10px;
      color: $rfx-bright-blue;
    }

    &__text {
      font-size: 13px;
      line-height: 2.3;
      margin-top: -5px;
      word-break: break-word;
    }
  }
</style>
